import Base from '@/plugins/Base';
import router from '@/plugins/Router'
import UndergraduateTransferService from '@/services/UndergraduateTransferService'
import showErrors from '@/helpers/showErrors'

const module = {
    namespaced: true,
    state: () => ({
        data: {},
        nationalID: null,
        pin: null,
        time: null
    }),
    getters: {
        getData(state) {
            return state.data
        },
        getStatus(state){
            return state.data && state.data.status ? state.data.status:null;
        },
        getNationalID(state) {
            return state.nationalID
        },
        getPin(state) {
            return state.pin
        },
        getTime(state) {
            return state.time
        }
    },

    mutations: {
        setData(state, data) {
            state.data = data
            Base.LocalStorage.set('conservatory_app_data', state.data)
        },
        setStatus(state, status) {
            state.data.status = status;
            Base.LocalStorage.set('undergraduate_transfer_data', state.data)
        },
        setNationalID(state, nationalID) {
            state.nationalID = nationalID
            Base.LocalStorage.set('conservatory_app_id', state.nationalID)
        },
        setPin(state, pin) {
            state.pin = pin
            Base.LocalStorage.set('conservatory_app_pin', state.pin)
        },
        setTime(state, time) {
            state.time = time
            Base.LocalStorage.set('conservatory_app_time', state.time)
        },
        clearData(state) {
            state.data = {}
            state.nationalID = null
            state.pin = null
        }
    },

    actions: {
        initData({commit}) {
            let data = Base.LocalStorage.get('conservatory_app_data')
            let nationalID = Base.LocalStorage.get('conservatory_app_id')
            let pin = Base.LocalStorage.get('conservatory_app_pin')
            let time = Base.LocalStorage.get('conservatory_app_time')
            if (data && nationalID && pin) {
                commit('setData', data)
                commit('setNationalID', nationalID)
                commit('setPin', pin)
                commit('setTime', time)
            }
        },

        isLogin({state}) {

            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (!data || !nationalID || !pin) {
                router.push('/conservatory/application/login')
            }
        },

        isLoginGoIndex({state}) {
            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (data && nationalID && pin) {
                router.push('/conservatory/application/form')
            }
        },

        logout({commit}) {
            commit('clearData')
            Base.LocalStorage.remove('conservatory_app_data')
            Base.LocalStorage.remove('conservatory_app_id')
            Base.LocalStorage.remove('conservatory_app_pin')
            Base.LocalStorage.remove('conservatory_app_time')

            router.push('/conservatory/application/login')
        }
    }
}

export default module;
